import { render, staticRenderFns } from "./to-destroy-target.vue?vue&type=template&id=1be6fe60&scoped=true"
import script from "./to-destroy-target.vue?vue&type=script&lang=js"
export * from "./to-destroy-target.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be6fe60",
  null
  
)

export default component.exports